import dynamic from 'next/dynamic';
import { useState, useRef, Fragment } from 'react';
import { toMoney } from '../../helpers';
import { submitClientRequest } from '../../helpers/clientRequest';
import { useLocationState } from '../../context/location';
import Input from '../Input';
import Textarea from '../Textarea';
import styles from '../../styles/modules/mortgage/MortgageCalculatorItem.module.scss';
import FormAgreement from '../FormAgreement';

const Modal = dynamic(() => import('../Modal'));

const MortgageCalculatorItem = ({ title, image, rate, payment, best }) => {
  const locationState = useLocationState();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isSubmited, setIsSubmited] = useState(false);
  const [clientName, setClientName] = useState('');
  const [clientPhone, setClientPhone] = useState('');
  const [clientComment, setClientComment] = useState('');
  const [agreeWithPolicy, setAgreeWithPolicy] = useState(false);
  const clientNameId = useRef();
  const clientPhoneId = useRef();

  const handleFormSubmit = () => {
    clientNameId.current.setError(clientName.length <= 3);
    clientPhoneId.current.setError(clientPhone.length !== 11);

    if (clientName.length > 3 && clientPhone.length === 11 && agreeWithPolicy) {
      submitClientRequest({
        clientName,
        clientPhone: clientPhone,
        clientComment,
        payment,
        bank: title,
        min_percent: rate,
        pathName: '/mortgage',
        whatComponent: 'MortgageCalculatorItem',
        location: locationState.name,
        platform: 'web'
      }).then((isSubmitted) => {
        if (isSubmitted) setIsSubmited(true);
      });
    }
  };

  return (
    <>
      <Modal
        title="Заявка на консультацию"
        button={!isSubmited && 'Отправить'}
        action={handleFormSubmit}
        visibility={isModalVisible}
        onClose={() => setIsModalVisible(false)}
        buttonDisabled={!agreeWithPolicy}
      >
        {isSubmited ? (
          <Fragment>
            <div style={{ marginBottom: 18 }}>Спасибо за заявку. Мы скоро с Вами свяжемся!</div>
            <img
              src="/images/thumbUp.png"
              alt=""
              style={{ padding: 50, width: '100%', boxSizing: 'border-box' }}
            />
          </Fragment>
        ) : (
          <Fragment>
            <div style={{ marginBottom: 18 }}>
              Оставьте свои контактные данные и мы с Вами свяжемся в самые кратчайшие сроки, поможем
              оформить ипотеку при необходимости!
            </div>
            <div className={styles.modalBank}>
              <div className={styles.modalBankTitle}>
                {!!image && <img src={image} alt={title} />}
                {title}
              </div>
              <div className={styles.modalBankLabels}>
                <div>
                  <span>Ставка</span> {rate}%
                </div>
                <div>
                  <span>Платеж</span> {toMoney(payment)} ₽/мес
                </div>
              </div>
            </div>
            <Input
              title="Имя"
              inputs={[
                {
                  placeholder: 'Василий Петрович',
                  value: clientName,
                  type: 'text'
                }
              ]}
              isWrappedStyle
              ref={clientNameId}
              onChange={(v) => setClientName(v[0])}
            />
            <Input
              title="Телефон"
              inputs={[
                {
                  placeholder: locationState.phone,
                  value: clientPhone,
                  mask: 'phone',
                  type: 'tel'
                }
              ]}
              isWrappedStyle
              ref={clientPhoneId}
              onChange={(v) => setClientPhone(v[0])}
            />
            <Textarea
              title="Коммментарий"
              placeholder="Например, «Помогите с подбором ипотеки, есть 300 000 рублей первоначального взноса»"
              autoHeight
              isWrappedStyle
              onChange={(v) => setClientComment(v)}
            />
            <FormAgreement onChange={setAgreeWithPolicy} />
          </Fragment>
        )}
      </Modal>
      <div
        className={styles.mortgage}
        role="button"
        tabIndex={-1}
        onClick={() => setIsModalVisible(true)}
      >
        <div className={styles.mortgageMain}>
          <div className={styles.mortgageBlock}>
            <div
              className={styles.mortgageIcon}
              style={{ backgroundImage: !!image && `url(${image})` }}
            >
              {!image && title.charAt(0).toUpperCase()}
            </div>
            <div className={styles.mortgageTitle}>
              {title}
              {best && <div className={styles.mortgageSubtitle}>Лучшее предложение</div>}
            </div>
          </div>
          <div className={styles.mortgageBlock}>
            <div className={styles.mortgageGroup}>
              <div className={styles.mortgageGroupTitle}>Ставка</div>
              <div className={styles.mortgageGroupText}>{rate} %</div>
            </div>
            <div className={styles.mortgageGroup}>
              <div className={styles.mortgageGroupTitle}>Платеж</div>
              <div className={styles.mortgageGroupText}>{toMoney(payment)} ₽</div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MortgageCalculatorItem;
